/* Greenleaf listicle: scroll-only CTAs, conditional mobile bar and review carousel. */
(() => {
  if (window.GreenleafListicle) return;
  const media = window.matchMedia('(max-width: 767px)');
  let cleanups = [];
  let refreshFrame;
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function resolveProduct(marker) {
    if (!marker) return null;
    const selector = marker.dataset.productSelector.trim();
    if (selector) {
      try { const target = document.querySelector(selector); if (target && !target.contains(marker)) return target; }
      catch (_) { /* Invalid optional selector: use the documented adjacent-section fallback. */ }
    }
    const wrapper = marker.closest('.shopify-section');
    const next = wrapper?.nextElementSibling;
    // Never mistake another section from this package for the native product section.
    return next?.classList.contains('shopify-section') && !next.querySelector('[data-gl-section]') ? next : null;
  }
  function initialize() {
    cleanups.forEach(fn => fn()); cleanups = [];
    const marker = document.querySelector('[data-gl-product-marker]');
    const product = resolveProduct(marker);
    const firstEnd = document.querySelector('[data-gl-first-end]');
    const bars = [...document.querySelectorAll('[data-gl-sticky]')];
    if (product) {
      const oldMargin = product.style.scrollMarginTop;
      product.style.scrollMarginTop = `${Number(marker.dataset.scrollOffset) || 0}px`;
      cleanups.push(() => { product.style.scrollMarginTop = oldMargin; });
    }
    function syncSticky() {
      const afterFirst = firstEnd && firstEnd.getBoundingClientRect().bottom <= 0;
      const rect = product?.getBoundingClientRect();
      const productVisible = rect && rect.bottom > 0 && rect.top < window.innerHeight;
      const visible = Boolean(media.matches && afterFirst && product && !productVisible);
      bars.forEach(bar => { bar.hidden = !visible; });
    }
    syncSticky();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(syncSticky, { threshold: 0 });
      if (firstEnd) observer.observe(firstEnd);
      if (product) observer.observe(product);
      cleanups.push(() => observer.disconnect());
    }
    const onLink = event => {
      const link = event.target.closest('[data-gl-cta]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = resolveProduct(document.querySelector('[data-gl-product-marker]')) || marker;
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
      target.focus({ preventScroll: true });
    };
    document.addEventListener('click', onLink);
    window.addEventListener('resize', syncSticky, { passive: true });
    media.addEventListener('change', syncSticky);
    cleanups.push(() => document.removeEventListener('click', onLink), () => window.removeEventListener('resize', syncSticky), () => media.removeEventListener('change', syncSticky));
    document.querySelectorAll('[data-gl-carousel]').forEach(carousel => {
      const track = carousel.querySelector('[data-gl-track]');
      const slides = [...carousel.querySelectorAll('[data-gl-slide]')];
      const prev = carousel.querySelector('[data-gl-prev]');
      const next = carousel.querySelector('[data-gl-next]');
      const count = carousel.querySelector('[data-gl-count]');
      if (!track || !slides.length) { if (prev) prev.disabled = true; if (next) next.disabled = true; return; }
      let index = 0;
      function update(i) {
        index = Math.max(0, Math.min(slides.length - 1, i));
        prev.disabled = index === 0; next.disabled = index === slides.length - 1;
        count.textContent = `${index + 1} / ${slides.length}`;
      }
      function go(i) {
        update(i);
        const destination = slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - 2;
        track.scrollTo({ left: destination, behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
      const onPrev = () => go(index - 1), onNext = () => go(index + 1);
      const onKey = event => {
        if (!media.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1));
      };
      prev.addEventListener('click', onPrev); next.addEventListener('click', onNext); track.addEventListener('keydown', onKey);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (media.matches && entry.isIntersecting && entry.intersectionRatio >= .6) update(slides.indexOf(entry.target)); });
        }, { root: track, threshold: [.6] });
        slides.forEach(slide => observer.observe(slide)); cleanups.push(() => observer.disconnect());
      }
      update(0);
      cleanups.push(() => prev.removeEventListener('click', onPrev), () => next.removeEventListener('click', onNext), () => track.removeEventListener('keydown', onKey));
    });
  }
  function refresh() { cancelAnimationFrame(refreshFrame); refreshFrame = requestAnimationFrame(initialize); }
  window.GreenleafListicle = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => document.addEventListener(name, refresh));
})();
